import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Radio from "../Icons/Radio";
const useStyles = makeStyles(({
  breakpoints,
  palette,
  typography
}) => ({
  title: {
    fontSize: typography.pxToRem(13),
    letterSpacing: 0.44,
    color: palette.text.responsibility,
    textAlign: "center",
    fontWeight: 500,
    [breakpoints.down("xs")]: {
      flex: 1,
      textAlign: "left"
    }
  },
  radioIcon: {
    [breakpoints.down("xs")]: {
      alignSelf: "flex-start"
    },
    "& .checkMark": {
      fill: palette.primary.main
    },
    cursor: "pointer",
    marginRight: typography.pxToRem(7)
  }
}));

const AcceptFullResponsibility = ({
  onSelect,
  selected,
  title,
  className
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    justify: "center",
    alignItems: "center",
    className: className
  }, /*#__PURE__*/React.createElement(Radio, {
    selected: selected,
    className: styles.radioIcon,
    onClick: onSelect
  }), /*#__PURE__*/React.createElement(Typography, {
    className: styles.title
  }, title));
};

export default AcceptFullResponsibility;